import * as React from 'react';
import { white } from '../colors';

/* eslint-disable max-len */
const ErrorSvg = (props: { [otherOptions: string]: unknown }) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    color={white}
    {...props}
  >
    <path
      d="M681 278c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm4.624 4.66l-11.611 11.612 2.68 2.68 11.611-11.612-2.68-2.68z"
      transform="translate(-669 -278)"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    />
  </svg>
);

export default ErrorSvg;
